import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Water Source Type List with Query (for remote operations)
export const getWaterSourceTypeListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_SOURCE_TYPES}?${stringifyParams(
			params
		)}`
	);
};

// Get Water Source Type List with Query
export const getWaterSourceTypeList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_SOURCE_TYPES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Water Source Type
export const getWaterSourceType = water_source_type_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_SOURCE_TYPE}${water_source_type_id}`
	);
};

// Add New Water Source Type
export const addNewWaterSourceTypeApi = water_source_type => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WATER_SOURCE_TYPE}`,
		water_source_type
	);
};

// Update Water Source Type
export const updateWaterSourceTypeApi = water_source_type => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WATER_SOURCE_TYPE}${water_source_type._id}`,
		water_source_type
	);
};

// Delete Water Source Type
export const deleteWaterSourceTypeApi = water_source_type_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WATER_SOURCE_TYPE}${water_source_type_id}`
	);
};

// Check if Water Source Type Exists
export const checkWaterSourceTypeExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_WATER_SOURCE_TYPE_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
